export async function generateHooks(
    assignments,
    rooms
) {
    const response = await fetch(
        "https://us-central1-figure-it-out-app.cloudfunctions.net/memoryPalace",
        {
            method: "POST",

            headers: {
                "Content-Type":
                    "application/json"
            },

            body: JSON.stringify({
                type: "hooks",
                assignments,
                rooms
            })
        }
    );

    return await response.json();
}